import { ReactNode } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { IconTextButton } from "../../atoms/IconTextButton";
import { defaultTheme } from "../../themes";

/**
 * [共通パーツ]Authページの共通部分
 */

type Props = {
  hasBackButton?: boolean;
  children?: ReactNode;
  onBackButtonClick?: () => void;
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 110px;
`;

const GoBackBlock = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
`;

export function AuthBase({
  hasBackButton = false,
  onBackButtonClick,
  children,
}: Props) {
  return (
    <Container>
      {hasBackButton && (
        <GoBackBlock>
          <IconTextButton
            text={"アカウント選択画面に戻る"}
            icon={
              <FontAwesomeIcon
                icon={"arrow-left"}
                color={defaultTheme.colors.brand}
              />
            }
            onButtonClick={onBackButtonClick}
          />
        </GoBackBlock>
      )}
      {children}
    </Container>
  );
}
